import React from 'react'
import { Link } from 'react-router-dom'

import { DATAU_HOMEPAGE } from '@/shared/constant/url'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { FooterBottom, FooterContents, FooterTop, FooterWrap } from '@/styles/common/footer'

const Footer = () => {
  type FooterOptionType = Array<{ title: string; link: string; tagName: string }>
  const { width } = useWindowDimensions()

  const FooterOption: FooterOptionType = [
    { title: '회사소개', link: DATAU_HOMEPAGE, tagName: 'a' },
    { title: '이용약관', link: '/terms/0/1', tagName: '' },
    { title: '개인정보처리방침', link: '/terms/0/2', tagName: '' },
    { title: '위치기반서비스이용약관', link: '/terms/0/3', tagName: '' },
    { title: '서비스 블로그', link: 'https://blog.naver.com/datau3', tagName: 'a' },
  ]

  return (
    <FooterWrap>
      <FooterContents>
        <FooterTop>
          <div className="left">
            <span>메타버스 라이프로깅 서비스</span>
            <p>Familycare</p>
          </div>
          <div className="right">
            {FooterOption.map((option) => (
              <React.Fragment key={option.title}>
                {option.tagName === 'a' ? (
                  <a href={option.link} target="_blank" rel="noreferrer">
                    {option.title}
                  </a>
                ) : (
                  <Link
                    to={`${option.link}`}
                    key={option.title}
                    onClick={() => window.scroll({ top: 0 })}
                  >
                    {option.title}
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>
        </FooterTop>
        <FooterBottom>
          <span>
            (주)데이터유니버스 ㅣ 대표: 강원석 ㅣ 서울특별시 영등포구 여의대로 70 원센티널 10층{' '}
            {width > 1200 ? '|' : <br />} 고객지원센터: 1855~3631 (공휴일 휴무: 09:00 ~ 12:00 /
            13:00 ~ 18:00)
          </span>
          <br />
          <span>Copyright 2021 DataUniverse. All Rights Reserved</span>
        </FooterBottom>
      </FooterContents>
    </FooterWrap>
  )
}
export default Footer
